<template>
  <div class="app-main-content">
    <div v-show="view==='list'" class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="225200"
          :expand-adv="true"
          :show-simple="false"
          :custom-search-items="customSearchItems"
          @advSearchItemCallBack="queryHandler"
        >
          <div slot="operations">
            <el-button type="success" :disabled="!selectedOne || hasSelectedMulti" no="view" @click="toDetail">{{ $t('CargoMsg.Cargo_View') }}</el-button>
            <el-button v-permission="['button_OpenPrice_edit']" type="success" :disabled="!selectedOne || hasSelectedMulti || isEditDisable" no="edit" @click="toEdit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <el-button v-permission="['button_OpenPrice_edit']" type="primary" no="add" @click="toAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button v-permission="['button_OpenPrice_edit']" type="primary" :disabled="!selectedOne || hasSelectedMulti" no="copy" @click="toCopy()">{{ $t('CargoMsg.Cargo_Copy') }}</el-button>
            <el-button v-permission="['button_OpenPrice_rpaControl']" type="primary" :disabled="!isRpaEnabled || !selectedOne || notRpaStart || hasSelectedMulti || selectedRowCompleted" no="start" @click="toStartRPA()">{{ $t('CargoMsg.Cargo_StartRPA') }}</el-button>
            <el-button v-permission="['button_OpenPrice_rpaControl']" type="danger" :disabled="!isRpaEnabled || !selectedOne || !notRpaStart || hasSelectedMulti || selectedRowCompleted" no="suspend" @click="toSuspendRPA()">{{ $t('CargoMsg.Cargo_SuspendRPA') }}</el-button>
            <el-button v-permission="['button_OpenPrice_importFinalResult']" type="primary" :disabled="!selectedOne || hasSelectedMulti" no="importFinalResult" @click="toImportFinalResult()">{{ $t('CargoMsg.Cargo_ImportFinalResult') }}</el-button>
            <el-button v-permission="['button_OpenPrice_edit']" type="primary" :disabled="!selectedOne || hasSelectedMulti || selectedRowCompleted" no="manuallyExportFile" @click="toExportFile">{{ $t('CargoMsg.Cargo_ManuallyExportFile') }}</el-button>
            <el-button v-permission="['button_OpenPrice_delete']" type="danger" :disabled="!hasSelected || isDeleteDisable" no="delete" @click="toDelete()">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper" style="position: relative">
          <cargo-ag-grid-wrapper
            config-module="225200"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-selected-color="false"
            :check-sub-record="false"
            style="height: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="225200"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="fetchDataByPage"
          />
        </div>
      </div>
    </div>
    <!-- 运价详情 -->
    <open-price-detail
      v-if="view==='detail'"
      ref="priceDetail"
      :source="viewSource"
      :company-codes="companyCodes"
      :lanes="lanes"
      :eq-sizes="eqSizes"
      :eq-types="eqTypes"
      :cargo-types="cargoTypes"
      :seaports="seaports"
      @back="toBack"
      @cancel="toCancel"
    />
    <!-- 操作日志 -->
    <open-price-oplog-dialog
      v-if="openPriceOplogDialog.visible"
      :visible.sync="openPriceOplogDialog.visible"
      :filing-batch-no="openPriceOplogDialog.filingBatchNo"
    />
    <!-- 导入最终结果 -->
    <import-final-result-dialog
      v-if="importFinalResultDialog.visible"
      :visible.sync="importFinalResultDialog.visible"
      :batch-uuid="importFinalResultDialog.batchUuid"
      :filing-batch-no="importFinalResultDialog.filingBatchNo"
      @importSuccess="toBack(viewSource)"
      @viewClick="onViewClick"
    />
    <!-- 运价详情-查看 -->
    <open-price-view
      v-if="view==='view'"
      ref="priceView"
      source="priceBatch"
      :data-changed="viewDataChanged"
      :rpa-enabled="rpaEnabled"
      :company-codes="companyCodes"
      :lanes="lanes"
      :eq-sizes="eqSizes"
      :eq-types="eqTypes"
      :cargo-types="cargoTypes"
      :seaports="seaports"
      @back="toBack"
      @cancel="toCancel"
      @edit="edit2View"
      @add="toAdd"
      @copy="toCopy"
      @startRpa="toStartRPA"
      @suspendRpa="toSuspendRPA"
      @importFinalResult="toImportFinalResult"
      @exportFile="toExportFile"
      @delete="toDelete"
    />
    <price-view-dialog
      v-show="priceViewDialog.visible"
      ref="priceViewDialog"
      :visible="priceViewDialog.visible"
      :price-batch="priceViewDialog.priceBatch"
      @close="() => priceViewDialog.visible=false"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import openPriceDetail from '@/views/cargo/v0/Price/OpenPriceBatch/components/openPriceDetail'
import openPriceView from '@/views/cargo/v0/Price/OpenPriceBatch/components/openPriceView'
import openPriceOplogDialog from '@/views/cargo/v0/Price/OpenPriceBatch/components/openPriceOplogDialog'
import importFinalResultDialog from '@/views/cargo/v0/Price/OpenPriceBatch/components/importFinalResultDialog'
import priceViewDialog from '@/views/cargo/v0/Price/OpenPriceBatch/components/priceViewDialog'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { queryOpenPriceBatch, deleteOpenPriceBatch, setRpaStatus, getDataMapping, manuallyExportFileExcel, queryRpaSetting } from '@/api/price/openPrice'
import { DocumentManage } from '@/utils/commonUtil'
import URL from '@/api/urlTranslator'
import { deepClone } from '@/utils'

export default {
  name: 'OpenPriceBatch',
  components: { cargoAgGridWrapper, searchItem, openPriceDetail, openPriceOplogDialog, importFinalResultDialog, openPriceView, priceViewDialog },
  data() {
    return {
      view: 'list',
      SystemConstants,
      loading: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        // 行点击触发事件
        onRowClicked: (event) => { this.selectedRow = event.data },
        onRowDoubleClicked: this.onRowDoubleClickedHandler
      },
      rowData: [],
      selectedRows: [],
      selectedRow: null,
      gridApi: null,
      customSearchItems: [], // 自定义高级查询项
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      documentManage: new DocumentManage(),
      openPriceOplogDialog: {
        visible: false,
        filingBatchNo: '' // 备案批次号
      },
      importFinalResultDialog: {
        visible: false,
        batchUuid: '',
        filingBatchNo: '' // 备案批次号
      },
      companyCodes: [], // 公司代码
      lanes: [], // 航线
      eqSizes: SeaExportConstants.SEA_EXPORT_BOX_TYPES, // 尺码
      eqTypes: [], // 箱型
      cargoTypes: [], // 货种
      seaports: [], // 海港
      viewSource: 'priceBatch', // 引用页面
      action: 'edit', // 页面操作
      viewDataChanged: false, // 是否变更过
      rpaEnabled: false, // 是否启用RPA
      priceViewDialog: {
        visible: false,
        priceBatch: {}
      },
      declareRows: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FilingBatchNo'), colId: 'filingBatchNo', field: 'filingBatchNo', initialWidth: 150, minWidth: 150,
          cellRenderer: params => {
            const methodOnPriceViewPath = this.documentManage.getPath('onPriceView')
            return `<a onclick="${methodOnPriceViewPath}('${params.data.uuid}')" style="color:blue">${params.value}</a>`
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FilingState'), colId: 'filingState', field: 'filingState', initialWidth: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.OpenPriceBatchStateLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EffectiveDate'), colId: 'effectiveDate', field: 'effectiveDate', initialWidth: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SubmitDate'), colId: 'submitDate', field: 'submitDate', initialWidth: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DeclareFinal'), colId: 'declareFinal', field: 'declareFinal', initialWidth: 160, minWidth: 160
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FiletotalRecordPass'), colId: 'filetotalRecordPass', field: 'filetotalRecordPass', initialWidth: 230, minWidth: 230
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Log'), colId: 'oplogMessage', field: 'oplogMessage', initialWidth: 250, minWidth: 250,
          cellRenderer: params => {
            const methodOnOplogShowPath = this.documentManage.getPath('onOplogShow')
            return (params.data.oplogMessage ? params.data.oplogMessage + `&nbsp;&nbsp;&nbsp;` : '') + `<a onclick="${methodOnOplogShowPath}('${params.data.uuid}')" style="color:blue">${this.$t('CargoMsg.Cargo_MoreDetails')}</a>`
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RpaState'), colId: 'rpaState', field: 'rpaState', initialWidth: 100, minWidth: 100, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.OpenPriceRpaStateLabelFun(params.value)
          }
        }
      ]
    },
    // 是否勾选
    hasSelected() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return false
      }
      return true
    },
    // 是否勾选多行
    hasSelectedMulti() {
      if (!this.hasSelected) {
        return false
      }
      return this.selectedRows.length > 1
    },
    // 选中行，批次状态为“已完成”
    selectedRowCompleted() {
      if (this.selectedOne && this.selectedOne.filingState === SystemConstants.OPEN_PRICE_BATCH_COMPLETED.code) {
        return true
      }
      return false
    },
    // 执行中、暂停、已完成状态，禁用编辑按钮
    isEditDisable() {
      if (this.selectedOne && (this.selectedOne.filingState === SystemConstants.OPEN_PRICE_BATCH_PROCESSING.code ||
        this.selectedOne.filingState === SystemConstants.OPEN_PRICE_BATCH_PAUSE.code ||
        this.selectedOne.filingState === SystemConstants.OPEN_PRICE_BATCH_COMPLETED.code)) {
        return true
      }
      return false
    },
    // 执行中、已完成状态，禁用删除按钮
    isDeleteDisable() {
      if (this.selectedOne && (this.selectedOne.filingState === SystemConstants.OPEN_PRICE_BATCH_PROCESSING.code ||
        this.selectedOne.filingState === SystemConstants.OPEN_PRICE_BATCH_COMPLETED.code)) {
        return true
      }
      return false
    },
    // 勾选单行数据
    selectedOne() {
      return this.hasSelected ? this.selectedRows[0] : null
    },
    // 能否启动RPA
    notRpaStart() {
      if (this.selectedOne && this.selectedOne.rpaState === SystemConstants.OPEN_PRICE_RPA_START.code) {
        return true
      }
      return false
    },
    // 是否启用RPA
    isRpaEnabled() {
      return this.rpaEnabled
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler(val) {
        await queryRpaSetting({ branchId: this.$store.getters.currentOfficeId }).then(res => {
          this.rpaEnabled = false
          if (res && res.data) {
            this.rpaEnabled = res.data.rpaEnabled
          }
        })
      }
    }
  },
  activated() {
    const { data: data, fromDeclare } = this.$route.params
    if (fromDeclare && data) {
      try {
        // 解析序列化的对象
        this.declareRows = data
        // 触发新增操作
        this.toAdd()
      } finally {
        delete this.$route.params.data
      }
    }
  },
  async created() {
    await this.initGridSpareData()
    await this.initDataMapping()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onOplogShow', function(value) {
      context.onOplogShow(value)
    })
    this.documentManage.set('onPriceView', function(value) {
      context.onPriceView(value)
    })
    this.documentManage.set('onViewClick', function(value) {
      context.onViewClick(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 航交所数据映射
    async initDataMapping() {
      await getDataMapping().then(res => {
        if (res && res.data) {
          const dataMapping = res.data
          // 分公司代码
          const companyCodeMappings = dataMapping.companyCodes || []
          if (companyCodeMappings.length > 0 && this.companyCodes.length > 0) {
            for (const mapping of companyCodeMappings) {
              for (const item of this.companyCodes) {
                if (mapping.sourceValue === item.code) {
                  item.code = mapping.targetValue
                  break
                }
              }
            }
          }
          // 航线
          const laneMappings = dataMapping.lanes || []
          if (laneMappings.length > 0 && this.lanes.length > 0) {
            for (const mapping of laneMappings) {
              for (const item of this.lanes) {
                if (mapping.sourceValue === item.code) {
                  item.code = String(mapping.targetValue)
                  break
                }
              }
            }
          }
          // 箱型
          const eqTypeMappings = dataMapping.eqTypes || []
          if (eqTypeMappings.length > 0 && this.eqTypes.length > 0) {
            for (const mapping of eqTypeMappings) {
              for (const item of this.eqTypes) {
                if (mapping.sourceValue === item.code) {
                  item.code = mapping.targetValue
                  break
                }
              }
            }
          }
          // 箱尺寸
          const eqSizeMappings = dataMapping.eqSizes || []
          if (eqSizeMappings.length > 0 && this.eqSizes.length > 0) {
            for (const mapping of eqSizeMappings) {
              for (const item of this.eqSizes) {
                if (mapping.sourceValue === item.code) {
                  item.code = mapping.targetValue
                  break
                }
              }
            }
          }
          // 货物类型
          const cargoTypeMappings = dataMapping.cargoTypes || []
          if (cargoTypeMappings.length > 0 && this.cargoTypes.length > 0) {
            for (const mapping of cargoTypeMappings) {
              for (const item of this.cargoTypes) {
                if (mapping.sourceValue === item.code) {
                  item.code = mapping.targetValue
                  break
                }
              }
            }
          }
          // 海港
          const seaportMappings = dataMapping.seaports || []
          if (seaportMappings.length > 0 && this.seaports.length > 0) {
            for (const mapping of seaportMappings) {
              for (const item of this.seaports) {
                if (mapping.sourceValue === item.code) {
                  item.code = mapping.targetValue
                  break
                }
              }
            }
          }
        }
      })
    },
    // 表格下拉等数据
    async initGridSpareData() {
      // 公司代码
      this.companyCodes = deepClone(getCacheListByKey(basicCacheKeys.basic_data_Office_All))
      this.companyCodes = this.companyCodes.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
      // 航线
      this.lanes = deepClone(getCacheListByKey(basicCacheKeys.basic_data_Region))
      // 箱型
      this.eqTypes = deepClone(getCacheListByKey(basicCacheKeys.basic_data_EQType))
      // 货物类型
      this.cargoTypes = deepClone(getCacheListByKey(basicCacheKeys.basic_data_CargoType))
      this.cargoTypes = this.cargoTypes.filter(p => p.sea === true) // 海运
      // 海港
      this.seaports = deepClone(getCacheListByKey(basicCacheKeys.basic_data_Seaport))
    },
    // 分页触发查询
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },
    onRowDoubleClickedHandler(event) {
      this.selectedRow = event.data
      if (this.selectedOne && this.selectedOne.uuid === this.selectedRow.uuid) {
        this.toDetail()
      }
    },
    queryHandler(data) {
      if (data) {
        this.filter.conditions = data
      }
      this.loading = getLoading4Cxt()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryOpenPriceBatch(this.filter).then(res => {
        this.handleQueryData(res)
      }).finally(() => {
        this.loading.close()
      })
    },
    handleQueryData(res) {
      const curSelected = this.gridApi.getSelectedRows().map(item => item.uuid)
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.selectedRow = null
      this.selectedRows = []
      //
      if (this.gridApi) this.gridApi.clearFocusedCell()
      if (curSelected.length) {
        this.$nextTick(() => {
          this.gridOptions.api.forEachNode(node => {
            if (node.data && node.data.uuid && curSelected.find((id) => id === node.data.uuid)) {
              node.setSelected(true)
            }
          })
        })
      }
    },
    toDetail() {
      if (!this.selectedOne) {
        return
      }
      if (this.view === 'list') {
        this.viewDataChanged = false
      }
      this.view = 'view'
      this.$nextTick(() => {
        this.$refs.priceView.originForm = this.selectedOne
        this.$refs.priceView.form = this.selectedOne
        this.$refs.priceView.init()
      })
    },
    edit2View(source = 'priceBatch') {
      this.toEdit(true, false, source)
    },
    toEdit(edit = true, copy = false, source = 'priceBatch') {
      if (!this.selectedOne) {
        return
      }
      this.viewSource = source
      this.action = copy ? 'copy' : 'edit'
      this.view = 'detail'
      this.$nextTick(() => {
        this.$refs.priceDetail.isEdit = edit
        this.$refs.priceDetail.isCopy = copy
        this.$refs.priceDetail.originForm = this.selectedOne
        this.$refs.priceDetail.form = this.selectedOne
        this.$refs.priceDetail.init()
      })
    },
    toBack(source = 'priceBatch') {
      console.log('source', source)
      console.log('action', this.action)
      if (source === 'priceView' && !['add', 'copy'].includes(this.action)) { // 查看页面
        this.viewDataChanged = true
        this.toDetail()
      } else {
        this.view = 'list'
        this.queryHandler()
      }
    },
    toCancel(source = 'priceBatch') {
      if (source === 'priceView') { // 查看页面
        this.toDetail()
      } else {
        this.view = 'list'
      }
    },
    async toAdd(source = 'priceBatch') {
      this.viewSource = source
      this.action = 'add'
      this.view = 'detail'
      await this.$nextTick()
      this.$refs.priceDetail.isEdit = true
      if (this.$refs.priceDetail) {
        await this.$refs.priceDetail.waitForGridInit()
      }
      await this.$refs.priceDetail.clearTableRows()
      if (this.declareRows && this.declareRows.length > 0) {
        try {
          await this.addMultipleRowsSerial() // 串行添加多行
        } catch (error) {
          this.$message.error(`添加数据失败：${error.message}`)
        } finally {
          // 清空 declareRows，避免下次 toAdd 时重复添加
          this.declareRows = []
        }
      }
    },
    async addMultipleRowsSerial() {
      // 遍历 declareRows，逐个添加并赋值（await 保证串行）
      for (let index = 0; index < this.declareRows.length; index++) {
        const declareRow = this.declareRows[index]
        // 封装子组件的回调式方法为 Promise，实现异步等待
        await new Promise((resolve, reject) => {
          this.$refs.priceDetail.toAddPrice(() => {
            try {
              // 调用子组件的赋值方法，传递当前行数据和索引
              this.$refs.priceDetail.setInitialData(declareRow, index)
              resolve() // 赋值完成，执行下一次循环
            } catch (error) {
              reject(error) // 赋值失败，终止循环
            }
          })
        })
      }
    },
    toCopy(source = 'priceBatch') {
      this.toEdit(true, true, source)
    },
    toStartRPA(source = 'priceBatch') {
      if (!this.selectedOne) {
        return
      }
      this.viewSource = source
      this.action = 'startRpa'
      const methodOnViewClickPath = this.documentManage.getPath('onViewClick')
      const viewClick = `<a onclick="${methodOnViewClickPath}('${this.selectedOne.uuid}')" style="color:blue">${this.selectedOne.filingBatchNo}</a>`
      this.$confirm(this.$t('CargoMsg.Cargo_SureToStartRPA', [viewClick]), this.$t('CargoMsg.Cargo_StartRPA'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_ConfirmR'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        confirmButtonClass: 'btn-custom-confirm',
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        this.setRpaState(SystemConstants.OPEN_PRICE_RPA_START.code)
      }).catch(() => {})
    },
    toSuspendRPA(source = 'priceBatch') {
      if (!this.selectedOne) {
        return
      }
      this.viewSource = source
      this.action = 'suspendRpa'
      const methodOnViewClickPath = this.documentManage.getPath('onViewClick')
      const viewClick = `<a onclick="${methodOnViewClickPath}('${this.selectedOne.uuid}')" style="color:blue">${this.selectedOne.filingBatchNo}</a>`
      this.$confirm(this.$t('CargoMsg.Cargo_SureToSuspendRPA', [viewClick]), this.$t('CargoMsg.Cargo_SuspendRPA'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_SuspendRPA2'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        confirmButtonClass: 'btn-custom-delete',
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        this.setRpaState(SystemConstants.OPEN_PRICE_RPA_SUSPEND.code)
      }).catch(() => {})
    },
    // 启动/暂停RPA
    setRpaState(rpaState) {
      this.loading = getLoading4Cxt()
      setRpaStatus({ uuid: this.selectedOne.uuid, rpaState: rpaState, filingBatchNo: this.selectedOne.filingBatchNo }).then(() => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
        this.toBack(this.viewSource)
      }).finally(() => {
        this.loading.close()
      })
    },
    async toDelete(source = 'priceBatch') {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      this.viewSource = source
      this.action = 'delete'
      const filingBatchNos = []
      const uuids = []
      for (const row of this.selectedRows) {
        // 已完成
        if (row.filingState === SystemConstants.OPEN_PRICE_BATCH_COMPLETED.code) {
          continue
        }
        filingBatchNos.push({ filingBatchNo: row.filingBatchNo, uuid: row.uuid })
        if (uuids.indexOf(row.uuid) === -1) uuids.push(row.uuid)
      }
      if (uuids.length === 0) return
      const methodOnViewClickPath = this.documentManage.getPath('onViewClick')
      let viewClick = ''
      for (const item of filingBatchNos) {
        viewClick += (viewClick ? '、' : '') + `<a onclick="${methodOnViewClickPath}('${item.uuid}')" style="color:blue">${item.filingBatchNo}</a>`
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToDeleteOpenPrice', [viewClick]), this.$t('CargoMsg.Cargo_Delete'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Delete'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        confirmButtonClass: 'btn-custom-delete',
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        this.doDelete(uuids)
      }).catch(() => {})
    },
    doDelete(uuids) {
      this.loading = getLoading4Cxt()
      deleteOpenPriceBatch({ uuidList: uuids }).then(() => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
        this.toBack()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 操作日志
    onOplogShow(value) {
      const item = this.rowData.find(x => x.uuid === value)
      this.openPriceOplogDialog.visible = true
      this.openPriceOplogDialog.filingBatchNo = item.filingBatchNo
    },
    toImportFinalResult(source = 'priceBatch') {
      if (!this.selectedOne) {
        return
      }
      this.viewSource = source
      this.action = 'importFinalResult'
      this.importFinalResultDialog.visible = true
      this.importFinalResultDialog.batchUuid = this.selectedOne.uuid
      this.importFinalResultDialog.filingBatchNo = this.selectedOne.filingBatchNo
    },
    toExportFile(source = 'priceBatch') {
      if (!this.selectedOne) {
        return
      }
      this.viewSource = source
      this.action = 'exportFile'
      const methodOnViewClickPath = this.documentManage.getPath('onViewClick')
      const viewClick = `<a onclick="${methodOnViewClickPath}('${this.selectedOne.uuid}')" style="color:blue">${this.selectedOne.filingBatchNo}</a>`
      this.$confirm(this.$t('CargoMsg.Cargo_SureToExportFile', [viewClick]), this.$t('CargoMsg.Cargo_ManuallyExportFile'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_ConfirmR'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        confirmButtonClass: 'btn-custom-confirm',
        cancelButtonClass: 'btn-custom-cancel',
        type: 'warning'
      }).then(() => {
        this.doExportFile()
      }).catch(() => {})
    },
    doExportFile() {
      this.loading = getLoading4Cxt()
      manuallyExportFileExcel({ batchUuid: this.selectedOne.uuid }).then(res => {
        this.exportResultHandler(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    exportResultHandler(result) {
      if (result.message) {
        this.$confirm(result.message, this.$t('Message.Error2'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('CargoMsg.Cargo_ConfirmR'),
          showCancelButton: false,
          type: 'error'
        }).then(() => {
          return
        }).catch(() => {})
      } else {
        // 从云存储上下载文件
        if (!result.documentId) {
          this.$message.warning(this.$t('SeaExport.NoCorrespondingFile'))
          return
        }
        const url = `${URL.common.findByFileId}/${result.documentId}?sessionId=${this.$store.getters.token}`
        window.open(url)
        this.toBack(this.viewSource)
      }
    },
    // 超链查看页面
    onPriceView(value) {
      if (value) {
        const item = this.rowData.find(x => x.uuid === value)
        this.selectedRows = []
        this.selectedRows.push(item)
        this.toDetail()
        // 默认勾选
        if (this.gridApi) this.gridApi.clearFocusedCell()
        this.$nextTick(() => {
          this.gridOptions.api.forEachNode(node => {
            if (node.data && node.data.uuid) {
              node.setSelected(value === node.data.uuid)
            }
          })
        })
      }
    },
    onViewClick(value) {
      if (value) {
        const item = this.rowData.find(x => x.uuid === value)
        this.priceViewDialog.priceBatch = item
        this.priceViewDialog.visible = true
        this.$refs.priceViewDialog.toDetail()
      }
    }
  }
}
</script>

<style lang="scss">
.btn-custom-cancel {
  float:left !important;
  margin-left: 250px !important;
}
.btn-custom-confirm {
  color: #FFFFFF !important;
  background-color: #006EBE !important;
  border-color: #006EBE !important;
  &:hover, &:focus {
    color: #FFFFFF !important;
    background-color: #006EBE !important;
    border-color: #006EBE !important;
  }
}
.btn-custom-delete {
  color: #FFFFFF !important;
  background-color: #F56C6C !important;
  border-color: #F56C6C !important;
  &:hover, &:focus {
    color: #FFFFFF !important;
    background-color: #F56C6C !important;
    border-color: #F56C6C !important;
  }
}
</style>
